import { useEffect, useState } from "react";
import CreatableSelector from "./CreatableSelector";
import { useLanguage } from "../../stores/LanguageStore";
import { IconArrowsRandom } from "@tabler/icons-react";
import { useAccountsStore } from "../../stores/ConfigStore";
import { createPool, getPools } from "../../api/EmailAPI";

const PoolSelector = ({
  value,
  setValue,
  type = "Email",
  required,
  withinPortal,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(true);
  const data = useAccountsStore((s) => s.email_pools);

  useEffect(() => {
    if (loading) {
      getPools().finally(() => setLoading(false));
    }
  }, [loading]);

  return (
    <CreatableSelector
      leftSection={<IconArrowsRandom size={16} />}
      label={"Pool"}
      placeholder={"Pool"}
      loading={loading}
      createLabel={"Créer le pool : "}
      data={data}
      createFunction={({ name }) => createPool({ name, type })}
      value={value}
      setValue={setValue}
      onDropdownOpen={() => setLoading(true)}
      onNewValueCreated={() => setLoading(true)}
      created_field_id={"pool_id"}
      required={required}
      withinPortal={withinPortal}
    />
  );
};

export default PoolSelector;
